/* eslint-disable no-secrets/no-secrets */
import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import metadata from './ProjectComponent.metadata.json5';

import styles from '../BuildersRisk.module.scss';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function ProjectComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('ProjectComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true

    const getDifferenceInMonth = () => {
        if(_.isUndefined(modelVM.comDatFie.year)) {
            return
        }
        
        const d1 = new Date(modelVM.proStaDatFie.year.value, modelVM.proStaDatFie.month.value, modelVM.proStaDatFie.day.value)
        const d2 = new Date(modelVM.comDatFie.year.value, modelVM.comDatFie.month.value, modelVM.comDatFie.day.value)

        let months;
        
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth();
        months += d2.getMonth();

        months = months <= 0 ? 0 : months;
        modelVM.totProMonFie.value = months;
        
        // eslint-disable-next-line consistent-return
        return months
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifOthPleDesFie: {
            visible: !_.isUndefined(modelVM.proDesFie.value) && modelVM.proDesFie.value.code === 'Oth'
        },
        ifYesExpFie: {
            visible: modelVM.wilTheBeAnyOccPritComFie.value === true
        },
        ifNewConPleSpeFie: {
            visible: !_.isUndefined(modelVM.proTypFie.value) && modelVM.proTypFie.value.code === 'NewCn'
        },
        staConTecFie: {
            visible: _.get(submissionVM.value, 'lobData.consTraAndServLine.coverables.buildersRisk.productCoveragesSelection.typofInsReqFie') === 'Bla'
        },
        ifYESdesproFie: {
            visible: _.get(submissionVM.value, 'lobData.consTraAndServLine.coverables.buildersRisk.productCoveragesSelection.typofInsReqFie') === 'Bla' && !_.isUndefined(modelVM.staConTecFie.value) && modelVM.staConTecFie.value
        },
        ifnoexpFie: {
            visible: _.get(submissionVM.value, 'lobData.consTraAndServLine.coverables.buildersRisk.productCoveragesSelection.typofInsReqFie') === 'Bla' && !_.isUndefined(modelVM.staConTecFie.value) && !modelVM.staConTecFie.value
        },
        totProMonFie: {
            value: getDifferenceInMonth(),
            readOnly: true
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            if(changedPath === 'doYouReqCovOnExistStrFie') {
                _.set(submissionVM, `lobData.consTraAndServLine.coverables.buildersRisk.existingStructure.isValidationReq`, value);
            } else if (changedPath === 'hasTheProAlrStaFie') {
                _.set(submissionVM, `lobData.consTraAndServLine.coverables.buildersRisk.constructionAlreadyCommenced.isValidationReq`, value);
            } else if (changedPath === 'doeTheProInCAnyRenFie') {
                _.set(submissionVM, `lobData.consTraAndServLine.coverables.buildersRisk.renovations.isValidationReq`, value);
            }

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ProjectComponent.propTypes = wizardProps;
export default withRouter(ProjectComponent);
